import { ACTION_STATUS } from "../actionbar-detail.constant";
import { ButtonBase } from "./button.base";

export class ItineraryWithPriceButtonModel extends ButtonBase {
    label: string = 'Confirmation with Price';
    action: string = ACTION_STATUS.itineraryWithPrice;
    matIconName: string = 'local_atm';
    colorClass: string = 'color-info-500';
}